module.exports = __webpack_public_path__ + "static/InTow-Connect-Mobile-Setup-bcf742dac3bca490da0ca1522de740a5.pdf";